// src/styles/formStyles.ts
//
// Form primitives shared by more than one form.
//
// RequiredMark lives here rather than in either form's own styles file because
// the contact form and the query form both need it and neither should own it.
// Those two forms share no other code, so keeping a copy in each would be the
// first thing to drift the moment the marker changed.
import styled from 'styled-components';

/**
 * The asterisk that marks a required field.
 *
 * Red rather than the label colour. A required marker is the only piece of
 * validation state a visitor can see before typing anything, and rendering it in
 * the same colour as the label makes it easy to miss on a form with four or five
 * fields in a row. The colour comes from `theme.required`, the single chromatic
 * token in an otherwise monochrome palette.
 *
 * aria-hidden by default, because the control's own `required` attribute is what
 * assistive technology already announces. Rendering it here would mean "Your
 * Name, required" twice, and a bare asterisk read aloud as "asterisk" is worse
 * than not reading it at all.
 */
export const RequiredMark = styled.span.attrs({ 'aria-hidden': true })`
  color: ${({ theme }) => theme.required};
  /* Tight, so the asterisk reads as punctuation attached to the label rather
     than as a separate word. */
  margin-left: 0.15em;
  font-weight: 700;
`;
